import React from 'react';
import ExpenseLedger from './ExpenseLedger';

const InvestorLedger: React.FC = () => {
  return <ExpenseLedger mode="investor" />;
};

export default InvestorLedger;
